<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    import { gettext as _ } from 'hydria/services/gettext'

    interface Props {
        modalClasses?: string
        headerClasses?: string
        bindActionKeys?: boolean
        children?: import('svelte').Snippet

        close?: () => void
        keep?: () => void
        mounted?: () => void
    }

    let { modalClasses = '', headerClasses = 'text-bg-primary', bindActionKeys = true, children, close = () => {}, keep = () => {}, mounted = () => {} }: Props = $props()

    const docHadModalClass = document.documentElement.classList.contains('modal-open')

    onMount(() => {
        if (!docHadModalClass) document.documentElement.classList.add('modal-open')
        mounted()
    })
    onDestroy(() => {
        if (!docHadModalClass) document.documentElement.classList.remove('modal-open')
    })
</script>

<style>
    .modal :global(.modal-header h5) {
        margin: 0;
    }
</style>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape' && bindActionKeys) close()
        else if (e.key == 'Enter' && e.ctrlKey && bindActionKeys) keep()
    }}
/>

<div class="modal" role="dialog">
    <div class="modal-dialog{modalClasses ? ` ${modalClasses}` : ''}" transition:fade={{ duration: 250 }}>
        <div class="modal-content">
            {#if children}{@render children()}{:else}
                <div class="modal-header{headerClasses ? ` ${headerClasses}` : ''}">
                    <div>Modal</div>
                </div>
                <div class="modal-body">Contenu</div>
                <div class="modal-footer"><button type="button" onclick={() => close()}>Fermer</button></div>
            {/if}
        </div>
    </div>
    <div
        class="modal-backdrop"
        aria-hidden="true"
        onclick={() => {
            close()
        }}
    ></div>
</div>
